import { setToastMessage } from './toastSlice';

export const handleApiError = async (dispatch: any, error: any) => {
  let errorMessage = 'An unexpected error occurred';

  try {
    // Check if the error data is a Blob and parse it
    if (error?.data instanceof Blob) {
      const text = await error.data.text();
      try {
        error.data = JSON.parse(text);
        errorMessage = error.data?.message || errorMessage;
      } catch (parseError) {
        console.error('Failed to parse error blob as JSON:', parseError);
        errorMessage = text; 
      }
    }


    if (error?.status === 401) {
      return; 
    }

    if (error?.data?.data?.message) {
      errorMessage = error.data.data.message;
    } else if (error?.data?.message) {
      errorMessage = error.data.message;
    } else if (error?.data?.error) {
      errorMessage = error.data.error;
    } else if (error?.error) {
      errorMessage = error.error;
    }

    if (typeof errorMessage === 'string' && errorMessage.startsWith('{') && errorMessage.endsWith('}')) {
      try {
        const parsedMessage = JSON.parse(errorMessage);
        errorMessage = parsedMessage.message || errorMessage;
      } catch {
        console.error('Failed to parse error message as JSON:', errorMessage);
      }
    }
  } catch (e) {
    console.error('Error handling API error:', e);
  }

  // Dispatch the error message to the toast
  dispatch(setToastMessage(errorMessage));
};